import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class SummaryMainScore extends React.Component {
  render() {
    let data = this.props.data;
    let workflow = data.workflow;
    let detail = data.project.detail;
    
    let influencer_count = Object.keys(workflow.influencers).length;
    
    let survival_count = detail.score_survival_count;
    let survival = detail.score_survival_per;
    
    let reply_count = detail.score_reply_count;
    let reply = detail.score_reply_per;
    
    let permission_count = detail.score_permission_count;
    let permission = detail.score_permission_per;
    
    let ng_count     = detail.score_ng_count;
    let assign_count = detail.score_assign_count;
    
    let items = [
      { id: 'influencers', name: 'インフルエンサー人数', value: influencer_count, type: 'person' },
      { id: 'survival',    name: 'NG率',                 value: survival,         type: 'percent', count: <h6>(候補者: {survival_count}人)<br />(NG数: {ng_count}人)</h6>,   help: <p>キャンペーン内の全候補者（候補者、対象外、アサイン対象の合計）<br />に対する「アサイン対象人数」を割った残り候補者の割合</p> },
      { id: 'reply',       name: '返信率',               value: reply,            type: 'percent', count: <h6>(アサイン数: {assign_count}人)<br />(未返信者: {reply_count}人)</h6>,      help: <p>アサイン対象者に対して「何かしらの返信があった人数」の割合<br />（辞退連絡等も含む）</p> },
      { id: 'permission',  name: '起用率',               value: permission,       type: 'percent', count: <h6>(起用数: {permission_count}人)</h6>, help: <p>アサイン対象者に対して「案件OK人数」の割合<br />（ワークフローで「2.投稿まで」以降のユーザーが対象）</p> },
    ];
    
    return (
      <div className="summary-main-score">
        { items.map((d, key) => {
          return (
            <div key={key} className="score-item">
              <h3>
                <span>{d.name}</span>
                { (d.help != undefined) &&
                  <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip>{d.help}</Tooltip>}>
                    <i className="material-icons">info</i>
                  </OverlayTrigger>
                }
              </h3>
              <h4>
                {d.value}
                {(d.type == 'percent') ? <span>%</span> : <span>人</span>}
              </h4>
              {(d.count != undefined) && d.count }
            </div>
          );
        })}
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryMainScore;